import { render, staticRenderFns } from "./MFlashMessages.vue?vue&type=template&id=1a267c6a&scoped=true&lang=pug&"
import script from "./MFlashMessages.vue?vue&type=script&lang=js&"
export * from "./MFlashMessages.vue?vue&type=script&lang=js&"
import style0 from "./MFlashMessages.vue?vue&type=style&index=0&id=1a267c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a267c6a",
  null
  
)

export default component.exports